export default __webpack_public_path__ + "static/media/landscape_plan.c3048fa5.jpg";